<div class="otp-login-signup-box">
  <div class="modal-body cstm_modal_Nmodal">

    <div class="heading_modal">
      <h2 id="otp-login-heading" class="h3">{{customerLogin.isNew && customerLogin.isToken ? 'Signup' : 'Login'}}</h2>
    </div>

    <form [formGroup]="loginOtpForm">
      <div [hidden]="customerLogin.isVerified" class="modal_flex">
        <label for="otpMobile" class="d-block text-left font-weight-bold">Enter your Mobile number
          <button type="button" [hidden]="!customerLogin.isToken" style="background:none;border:none;color:#c10a28;cursor:pointer;padding:0;font-size:inherit;" (click)="changeNumber()">(Change Number)</button>
        </label>

        <div class="form-group">
          <div class="text-box-wrap">
            <input type="tel" id="otpMobile" numberOnly formControlName="mobile" class="form-control"
              [ngClass]="{'is-invalid': formErrors.mobile}" placeholder="Mobile number" maxlength="10"
              autocomplete="tel" aria-required="true"
              [attr.aria-invalid]="fc.mobile.invalid && fc.mobile.touched"
              [attr.aria-describedby]="fc.mobile.errors ? 'otpMobileError' : null">
            <div *ngIf="fc.mobile.errors" id="otpMobileError" class="invalid-feedback" role="alert">
              Please enter valid phone number
            </div>
          </div>
        </div>
        <strong> <label class="welcome-name" *ngIf="!customerLogin.isNew && customerLogin.isToken">Welcome Back!
            {{customerLogin.customerName}}
          </label></strong>
        <div *ngIf="customerLogin.isToken">
          <label for="otpToken" class="d-block text-left font-weight-bold">Enter the 4-digit code sent to your mobile number</label>
          <div class="text-box-wrap">
            <input type="text" id="otpToken" numberOnly formControlName="otp" class="form-control"
              [ngClass]="{'is-invalid': formErrors.otp}" placeholder="OTP" maxlength="4"
              autocomplete="one-time-code" aria-required="true"
              [attr.aria-invalid]="fc.otp.invalid && fc.otp.touched"
              [attr.aria-describedby]="fc.otp.errors ? 'otpTokenError' : null">
            <div *ngIf="fc.otp.errors" id="otpTokenError" class="invalid-feedback" role="alert">
              <div *ngIf="fc.otp.errors">
                Please enter 4-digit valid otp
              </div>
            </div>
          </div>

          <div class="modal_links">
            <button type="button" style="background:none;border:none;color:#c10a28;cursor:pointer;padding:0;" (click)="resendOtp(false)">Resend OTP</button>
            <button type="button" style="background:none;border:none;color:#c10a28;cursor:pointer;padding:0;" (click)="resendOtp(true)">Get OTP over call</button>
          </div>
        </div>
      </div>

      <div class="w-100" *ngIf="customerLogin.isVerified && customerLogin.isNew">
        <div class="form-group">
          <div class="text-box-wrap">
            <label for="otpFullName" class="d-block text-left font-weight-bold">Enter your full name</label>
            <input type="text" id="otpFullName" formControlName="name" class="form-control" placeholder="Full Name" maxlength="50"
              autocomplete="name" aria-required="true"
              [ngClass]="{'is-invalid': formErrors.name}"
              [attr.aria-invalid]="fc.name.invalid && fc.name.touched"
              [attr.aria-describedby]="fc.name.errors ? 'otpNameError' : null">
            <div *ngIf="fc.name.errors" id="otpNameError" class="invalid-feedback" role="alert">
              <div *ngIf="fc.name.errors.required">
                Please enter your full name
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="text-box-wrap">
            <label for="otpEmail" class="d-block text-left font-weight-bold">Enter your email</label>
            <input type="email" id="otpEmail" formControlName="email" class="form-control" maxlength="50" (keyup)="trimEmail()"
              placeholder="Email Address" autocomplete="email" aria-required="true"
              [ngClass]="{'is-invalid': formErrors.email}"
              [attr.aria-invalid]="fc.email.invalid && fc.email.touched"
              [attr.aria-describedby]="fc.email.errors ? 'otpEmailError' : null">
            <div *ngIf="fc.email.errors" id="otpEmailError" class="invalid-feedback" role="alert">
              <div *ngIf="fc.email.errors">
                Please enter your email
              </div>
            </div>
          </div>
        </div>

        <div class="form-group w-100">
          <div class="text-left">
            <input type="checkbox" id="otpTc" formControlName="tc">
            <label for="otpTc" class="d-inline ml-1">By continuing, you agree to the member's <a target="_blank" rel="noopener noreferrer"
              aria-label="Terms & Conditions (opens in a new window)"
              [routerLink]="['/home/tc']">Terms & Conditions</a> and <a target="_blank" rel="noopener noreferrer"
              aria-label="Privacy Policy (opens in a new window)"
              [routerLink]="['/home/privacy-policy']">Privacy Policy</a>.</label>
          </div>
        </div>
      </div>
      <div>
        <div class="form-group">
          <button type="button" [disabled]="!loginOtpForm.valid" [ngStyle]="clientConfig.style.bg" (click)="onSubmit()" id="ContinueAsLoginOrSignup" class="app-btn btn btn-danger btn-block"
          [ngClass]="(clientConfig?.outlet?.deliveryType === deliveryType.Pickup && clientConfig?.outlet?.scheduleOrder) ? 'p-po-ptc-' + getButtonText() + '-as-member' :
                    (clientConfig?.outlet?.deliveryType === deliveryType.Pickup && !clientConfig?.outlet?.scheduleOrder) ? 'p-on-ptc-' + getButtonText() + '-as-member' :
                    (clientConfig?.outlet?.deliveryType === deliveryType.Delivery && clientConfig?.outlet?.scheduleOrder) ? 'd-po-ptc-' + getButtonText() + '-as-member' :
                    'd-on-ptc-' + getButtonText() + '-as-member'" >{{ getButtonText() }}</button>
        </div>
      </div>
    </form>
  </div>
</div>